export const copyToClipboard = (str: string) => {
  if (typeof navigator.clipboard !== 'undefined') {
    return navigator.clipboard.writeText(str)
  }

  // fallback to ie: https://developer.mozilla.org/en-US/docs/Web/API/Navigator/clipboard#browser_compatibility
  const el = document.createElement('textarea')
  el.value = str
  document.body.appendChild(el)
  el.select()

  try {
    // only ie
    // eslint-disable-next-line deprecation/deprecation
    document.execCommand('copy')
  } finally {
    document.body.removeChild(el)
  }
}
